import { render, staticRenderFns } from "./EditFAQForm.vue?vue&type=template&id=4d236aee&scoped=true&"
import script from "./EditFAQForm.vue?vue&type=script&lang=js&"
export * from "./EditFAQForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d236aee",
  null
  
)

export default component.exports